import { render } from "./FrenchWay.vue?vue&type=template&id=7d64017a&ts=true"
import script from "./FrenchWay.vue?vue&type=script&lang=ts"
export * from "./FrenchWay.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__